import { useMutation } from "@tanstack/react-query";
import { amiCommandApi } from "@/lib/api";

export function useAmiCommand() {
  return useMutation({
    mutationFn: (command: string) => amiCommandApi.run(command),
  });
}